'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

import RenderBuilderContent from 'components/Builder/BuilderComponent';
import PageHeaderHero from 'components/Heros/PageHeaderHero';

type PageHeaderHeroProps = {
  backgroundColor?: 'grey' | 'white' | undefined;
  eyebrow?: string | undefined;
  subhead?: string | undefined;
  contents?:
    | {
        body?: string | undefined;
        ctas?:
          | {
              label?: string | undefined;
              link?: string | undefined;
              type?: 'button' | 'arrow' | undefined;
            }[]
          | undefined;
        embed?: string | undefined;
      }[]
    | undefined;
};

const pageData: PageHeaderHeroProps = {
  eyebrow: 'Page Not Found',
  contents: [
    {
      body: 'The requested page could not be found.',
      ctas: [
        {
          label: 'Search this site',
          link: '/search',
          type: 'arrow',
        },
        {
          label: 'Back to home page',
          link: '/',
          type: 'arrow',
        },
      ],
    },
  ],
  backgroundColor: 'white',
};

const NotFoundComponent = () => {
  const searchParams = useSearchParams();
  const inVisualEditor = searchParams?.get('__builder_editing__') === 'true';
  const model = searchParams?.get('builder.preview') || 'page';

  if (inVisualEditor) {
    return <RenderBuilderContent model={model} />;
  }

  return <PageHeaderHero {...pageData} />;
};

const NotFound = () => (
  <Suspense fallback={null}>
    <NotFoundComponent />
  </Suspense>
);

export default NotFound;
